const storeAvailabilityContainer = document.querySelector('.product-single__store-availability-container'),
  variantData = storeAvailabilityContainer.dataset,
  dataset = getData(variantData);


async function callProductData(productName, variant) {
  const urlString = window.location.origin + '/products/' + productName + '?variant=' + variant
  url = urlString.includes('?') ? `${urlString}&view=json` : `${urlString}?view=json`;
  try {
    const response = await fetch(url, {
        mode: 'no-cors'
      }),
      data = await response.json();
    return data
  } catch (err) {
    console.error(err);
  }
};

function getData(data) {
  const obj = {}
  for (const key in data) {
    obj[key] = data[key];
  }
  return obj
}

function buildProductFormEl(locationName, data, variantData, size) {
  html = `
    <div class="store-availability-information">
      ${ data.available == 'true'  ? variantData.iconInStock : variantData.iconOutOfStock }
        <div class="store-availability-information-container">
        ${ data.available == 'true'  ?
          ` <p class="store-availability-information__title">
          ${variantData.pickUpAvailableAtHtml.replace('{{ location_name }}', locationName)}
        </p>
        <p class="store-availability-information__stock store-availability-small-text">
          ${data.pick_up_time}
        </p>
        <div class="store-availability-information__button js-modal-open-store-availability-modal store-availability-small-text" data-store-availability-modal-open aria-haspopup="dialog">
          Click here for pick up address
        </div>`:
        ` <p class="store-availability-information__title">
          ${variantData.pickUpUnavailableAtHtml.replace('{{ location_name }}', locationName)}
        </p>
        ${size > 1 ? 
        `<div class="store-availability-information__button js-modal-open-store-availability-modal store-availability-small-text" data-store-availability-modal-open aria-haspopup="dialog">
          ${variantData.checkOtherStores}
        </div>`: `` }`
        }
      </div>
    </div>`
  return html
}

function buildModalEl(arr, variantData, activeVariant) {
  let innerHTML = ``;
  const body = document.querySelector('body').classList.contains('store-availabilities-modal--active')

  function buildAddress(data) {

    let innerHTML = '';
    const excludeList = ['latitude', 'longitude', 'country_code', 'province_code', 'address2'];
    for (const key in data) {
      if (data[key] && !excludeList.includes(key)) {
        innerHTML += `${data[key]}<br>`
      }
    }
    return `
    <p class="store-availability-list__phone store-availability-small-text">
    ${innerHTML}
    </p>
    `
  }

  for (const key in arr) {
    innerHTML += `<li class="store-availability-list__item">
    <h3 class="store-availability-list__location">
     ${key}
    </h3>
    <div class="store-availability-list__stock store-availability-small-text">
    ${ arr[key].available == 'true'  ? variantData.iconInStock + variantData.pickUpAvailableAtHtml.replace('{{ location_name }}', key) + ` <br> `+ arr[key].pick_up_time :

    variantData.iconOutOfStock + variantData.pickUpUnavailableAtHtml.replace('{{ location_name }}', key)}
    </div>
    <address class="store-availability-list__address">
      ${buildAddress(arr[key].address)}
    </address>
    </li>
    `
  }

  return `
  <div
      class="store-availabilities-modal modal ${body && `store-availabilities-modal--active` }"
      id="StoreAvailabilityModal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="StoreAvailabilitiesModalProductTitle"
    >
    <div class="store-availabilities-modal__header">
      <div class="store-availabilities-modal__product-information">
        <h2
          id="StoreAvailabilitiesModalProductTitle"
          class="store-availabilities-modal__product-title"
          data-store-availability-modal-product-title
        >
        ${variantData.productTitle}
        </h2>
        <p
          class="store-availabilities-modal__variant-title store-availability-small-text"
          data-store-availability-modal-variant-title
        >
        ${activeVariant.title}
        </p>
      </div>
      <div
        class="store-availabilities-modal__close js-modal-close-store-availability-modal text-link"
        aria-label="{{ 'general.accessibility.close_modal' | t }}"
      >
        ${variantData.iconClose}
      </div>
    </div>
    <ul class="store-availabilities-list" role="list">
    ${innerHTML}
    </ul>
    </div>
  </div>
  `
}

function waitForEl(selector, callback) {
  if ($(selector).length) {
    callback();
  } else {
    setTimeout(function () {
      waitForEl(selector, callback);
    }, 100);
  }
};

function searchID(nameKey, myArray) {
  for (var i = 0; i < myArray.length; i++) {
    if (myArray[i].id === parseInt(nameKey)) {
      return myArray[i];
    }
  }
}

function addEvents(el) {
  el.addEventListener('click', function () {
    const arr = [document.querySelector('html'), document.querySelector('body'), document.querySelector('.store-availabilities-modal')];
    arr.forEach((el) => {
      el.classList.toggle("store-availabilities-modal--active")
    })
  })
}

function buildAllEls(data,activeVariant) {
  const storeData = data['store-availability'],
    closest_location = storeData.locations[`${Object.keys(storeData.locations)[0]}`],
    locationName = Object.keys(storeData.locations)[0];
  storeAvailabilityContainer.innerHTML = `
  <div class="store-availability-container">${buildProductFormEl(locationName,closest_location,variantData,storeData.size) + buildModalEl(storeData.locations,variantData,activeVariant)}
  </div>`
}
window.addEventListener('load', function () {
  const selectMenu = document.querySelector('#SingleOptionSelector-0');

  callProductData(dataset.productHandle, dataset.variantId).then((data) => {
    const activeVariant = searchID(dataset.variantId, data.variants);
    buildAllEls(data,activeVariant)
  });
    
  selectMenu.addEventListener('change', function() {
    const variantId = selectMenu.options[selectMenu.selectedIndex].dataset.id;
 
    callProductData(dataset.productHandle, variantId).then((data) => {
      const activeVariant = searchID(variantId, data.variants);
      buildAllEls(data,activeVariant)
      waitForEl('.store-availability-information__button', function () {
        [document.querySelector('.store-availability-information__button'), document.querySelector('.store-availabilities-modal__close')].forEach((el) => {
          addEvents(el)
        })
      })
  })
});

  waitForEl('.store-availability-information__button', function () {
    [document.querySelector('.store-availability-information__button'), document.querySelector('.store-availabilities-modal__close')].forEach((el) => {
      addEvents(el)
    })
  });

}, false);

